import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Helpers } from "@core/utils/helpers";
import { ConfigService } from "@core/data/config.service";
import { ListPcpResponse as ListPcpResponseV3 } from "@core/interfaces/3rdparty/pcp/v3/list-pcp-response";
import { ListPcp as ListPcpV3 } from "@core/interfaces/3rdparty/pcp/v3/list-pcp";
import { ListPcpResponse as ListPcpResponseV2 } from "@core/interfaces/3rdparty/pcp/v2/list-pcp-response";
import { ListPcp as ListPcpV2 } from "@core/interfaces/3rdparty/pcp/v2/list-pcp";

@Injectable({
    providedIn: "root",
})
export class PcpService {
    private root: string;

    constructor(
        private conf: ConfigService,
        private httpClient: HttpClient,
    ) {
        this.conf.populate().subscribe(() => {
            this.root = this.conf.getPCPConfig();
        });
    }

    listPcp(query: ListPcpV2): Observable<ListPcpResponseV2> {
        return this.httpClient.get<ListPcpResponseV2>(`${this.root}/api/v2/search/providers`, {
            params: Helpers.prepareGetParamsFromObject(query, true),
        });
    }

    listPcpV3(query: ListPcpV3): Observable<ListPcpResponseV3> {
        return this.httpClient.get<ListPcpResponseV3>(`${this.root}/api/v3/providers/search`, {
            params: Helpers.prepareGetParamsFromObject(query, true),
        });
    }
}
